import React from 'react';
import {connect} from 'react-redux';
import {addJustification} from '../../redux/planning/actions';
import {JUSTIFICATION_ITEMS, CSS_NAMES_FOR_JUSTIFICATIONS_ITEMS} from '../../config';
import Modal from 'react-modal';

/** Popup d'ajout de justifications pour un jour */
@connect(
  () => ({}),
  {addJustification}
)
export default class extends React.Component {

  onItemClicked(message) {
    const {groomer, selectedDay} = this.props;
    const year = this.props.year;
    const month = this.props.month;
    this.props.addJustification(groomer, year, month, selectedDay, message);
    this.props.onClose();
 }

  render() {
    const selectedDay = this.props.selectedDay;
    const modalStyle = {
      overlay: {
        backgroundColor: 'rgba(0,0,0,0)',
        zIndex: 100000
      },
      content: {
        left: `calc(${selectedDay * 1.5}vw + ${selectedDay * 2}px + 2px - 40px)`,
        top: `calc(222px + ${this.props.idx * 25}px)`
      }
    };

    return (
      <Modal isOpen={true} contentLabel="Justification" style={modalStyle} className="justification-popup"
        onRequestClose={this.props.onClose}>
          <div className="justification-header">
            Justifications
          </div>
          <div className="justification-actions">
            { JUSTIFICATION_ITEMS.map(m =>
              <button key={m} onClick={() => this.onItemClicked(m)}
                className={CSS_NAMES_FOR_JUSTIFICATIONS_ITEMS[m]}>{m}</button>) }
          </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SupportMessages/JustificationPopup.js